import { render, staticRenderFns } from "./frequent_item_skeleton.vue.js?vue&type=template&id=12558543&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./frequent_item_skeleton.vue?vue&type=template&id=12558543&vue3"
import script from "./frequent_item_skeleton.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./frequent_item_skeleton.vue?vue&type=script&lang=js&vue3"
export * from "./frequent_item_skeleton.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./frequent_item_skeleton.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports